import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatSelectModule } from '@angular/material/select'
import { PipesModule } from '@mmx/pipes'
import { TranslateModule } from '@ngx-translate/core'
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search'

import { CustomFieldModule } from '../custom-field'
import { SelectAllOptionComponent } from '../select-all-option'
import { ReferrerSelectorFieldComponent } from './referrer-selector.component'

@NgModule({
  imports: [
    CommonModule,
    CustomFieldModule,
    FlexModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
    ReactiveFormsModule,
    PipesModule,
    TranslateModule,
    SelectAllOptionComponent,
  ],
  declarations: [ReferrerSelectorFieldComponent],
  exports: [ReferrerSelectorFieldComponent],
})
export class ReferrerSelectorModule {}
